var map = {
	"./adminprofile/add": [
		1958,
		18
	],
	"./agentprofile/add": [
		1959,
		21
	],
	"./ai_assistant/add": [
		1960,
		24
	],
	"./api_key/add": [
		1961,
		27
	],
	"./canned_answer/add": [
		1962,
		32
	],
	"./chat_configuration/add": [
		1963,
		5
	],
	"./client/add": [
		1964,
		35
	],
	"./disposition/add": [
		1965,
		40
	],
	"./field/add": [
		1966,
		43
	],
	"./form/add": [
		1967,
		46
	],
	"./form_website/add": [
		1968,
		49
	],
	"./invoice_post/add": [
		1969,
		56
	],
	"./journey/add": [
		1970,
		59
	],
	"./journey_draft/add": [
		1971,
		62
	],
	"./journey_variable/add": [
		1972,
		66
	],
	"./list/add": [
		1973,
		69
	],
	"./list_file/add": [
		1974,
		72
	],
	"./mail_account/add": [
		1975,
		75
	],
	"./operational_hours/add": [
		1976,
		78
	],
	"./organization/add": [
		1977,
		81
	],
	"./pause/add": [
		1978,
		84
	],
	"./phonenumber_monthly_cost/add": [
		1979,
		87
	],
	"./phonenumber_monthly_cost_parent/add": [
		1980,
		90
	],
	"./phonenumber_purchase/add": [
		1981,
		94
	],
	"./phonenumber_setup_cost/add": [
		1982,
		97
	],
	"./phonenumber_setup_cost_parent/add": [
		1983,
		100
	],
	"./prepaid_credit/add": [
		1984,
		107
	],
	"./queue/add": [
		1985,
		110
	],
	"./signature/add": [
		1986,
		114
	],
	"./skill/add": [
		1987,
		117
	],
	"./sla_policy/add": [
		1988,
		120
	],
	"./sound/add": [
		1989,
		123
	],
	"./stats_alarm/add": [
		1990,
		126
	],
	"./stats_custom_metric/add": [
		1991,
		129
	],
	"./stats_report/add": [
		1992,
		132
	],
	"./stats_widget/add": [
		1993,
		135
	],
	"./superadmin_profile/add": [
		1994,
		138
	],
	"./tag/add": [
		1995,
		141
	],
	"./tariff/add": [
		1996,
		144
	],
	"./tariff_parent/add": [
		1997,
		147
	],
	"./team/add": [
		1998,
		150
	],
	"./text_message_source/add": [
		1999,
		12
	],
	"./time_interval/add": [
		2000,
		154
	],
	"./user/add": [
		2001,
		157
	],
	"./voice_asterisk/add": [
		2002,
		160
	],
	"./voice_asterisk_downgrade/add": [
		2003,
		163
	],
	"./voice_route/add": [
		2004,
		170
	],
	"./voice_shortcut/add": [
		2005,
		173
	],
	"./voice_trunk/add": [
		2006,
		176
	],
	"./voice_voicemail/add": [
		2007,
		179
	],
	"./wallboard/add": [
		2008,
		182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1878;
module.exports = webpackAsyncContext;